import React from "react";
import { FormFieldLabel } from "../../../atoms/proc-management/form";
import { getMaxLength } from "../../../../application/domain/proc-management/util/input-max-length";
import { InputNoticeList } from "./input-notice-list";
import { SimpleTextInput } from "./simple-text-input";
import type { InputProps, PathProps } from "./types";

const notices = [
  "ユーザーが、手続きの対象者に自身があてはまるかどうかを一目で判断できるように、一言で記述します。",
  "例1: サンプル県に本社をおく事業者",
  "例2: サンプル市へ転入される個人の方",
];

type Props = InputProps & PathProps & { value?: string; errorMsg?: string };

export const ProcedureTargetInput: React.FC<Props> = ({
  onChange,
  disabled = false,
  basePath,
  value,
  shouldDisplayError = false,
  errorMsg,
}) => {
  return (
    <div className="field mb-6">
      <FormFieldLabel label="対象者" />
      <InputNoticeList notices={notices} />
      <SimpleTextInput
        onChange={onChange}
        basePath={basePath}
        value={value}
        disabled={disabled}
        shouldDisplayError={shouldDisplayError}
        errorMsg={errorMsg}
        maxLength={getMaxLength("procTarget")}
      />
    </div>
  );
};
